<div class="tag" [ngClass]="color">
  <span class="text-small text">{{ text }}</span>
</div>
